<template>
  <v-tooltip v-if="entries.length" location="top" max-width="320">
    <template v-slot:activator="{ props: activator }">
      <div
        v-bind="activator"
        class="item-exception-flag d-inline-flex align-center text-warning qtm-body-small font-weight-medium"
      >
        <v-icon class="mr-1" icon="mdi-alert-circle-outline" size="small" />
        {{ label }}
      </div>
    </template>
    <div v-for="(entry, i) in entries" :key="i" :class="{ 'mt-2': i > 0 }">
      <div v-if="entry.heading" class="font-weight-medium" v-text="entry.heading" />
      <div v-text="entry.text" />
    </div>
  </v-tooltip>
</template>

<script setup lang="ts">
export interface ExceptionEntry {
  heading?: string
  text: string
}

export interface Props {
  exception?: string | null
  exceptions?: ExceptionEntry[] | null
}

const props = defineProps<Props>()

const entries = computed<ExceptionEntry[]>(() => {
  if (props.exceptions?.length) {
    return props.exceptions
  }
  if (props.exception) {
    return [{ text: props.exception }]
  }
  return []
})

const label = computed(() => {
  const labels = entries.value
    .map(entry => (entry.text.split(':')[0] ?? '').trim())
    .filter(Boolean)
  return Array.from(new Set(labels)).join(', ')
})
</script>
